export default "/images/custom_development__icon.png";